"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  public: {
    filter: '过滤器:',
    orderName: '别名:',
    code: '编码:',
    InspectionOrderNo: '检验定单号'
  },
  statutory: {
    button: {
      query: '查询',
      reset: '重置',
      addition: '增加',
      add: '新增',
      export: '导出',
      confirm: '确认',
      save: '保存',
      saveAndAdd: '保存并新增',
      submit: '提交',
      release: '发布',
      cancel: '取消',
      goBack: '返回',
      operation: '操作',
      edit: '编辑',
      detail: '详情',
      delete: '删除'
    },
    public: {
      pleaseEnter: '请输入',
      mailAddress: '邮箱地址'
    }
  },
  statutoryMonitor: {
    statutoryStatistics: '统计法定情况',
    distributionCondition: '各船级社入级情况分布',
    inspectionTracking: '检验单跟踪',
    ship: '船舶',
    inspectionNo: '检验单号',
    inspectionType: '检验类别',
    plannedDate: '计划检验日期',
    completionDate: '检验完工日期',
    status: '检验状态',
    paymentStatus: '付款状态',
    certificateTracking: '证书跟踪',
    reminder: '证书到期提醒',
    certificateName: '证书名称',
    period: '检验窗口期',
    warning: '证书超期警告',
    expirationDate: '证书到期日',
    checkVessel: '请选择船舶',
    qtyCheck: '只能选择一条船舶进行操作'
  },
  certGroup: {
    index: {
      table: {
        groupNameCn: '分组名称(中文)',
        groupNameEn: '分组名称(英文)',
        groupName: '分组名称',
        superior: '上级分组',
        dispOrder: '显示顺序',
        lastTime: '最后操作时间',
        lastOperator: '最后操作人'
      },
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '船舶证书管理',
        menuThree: '证书分组管理'
      }
    },
    message: {
      saveCertGroupSuccess: '保存证书分组成功',
      saveCertGroupFail: '保存证书分组失败'
    },
    title: {
      groupMgt: '证书分组管理',
      addItem: '新增项目',
      addChildItem: '新增子项目',
      editItem: '编辑项目'
    },
    rules: {
      groupCode: '请填写分组编码',
      groupNameCn: '请填写分组名称(Cn)',
      groupNameEn: '请填写分组名称(En)'
    }
  },
  certificate: {
    common: {
      inUse: '在用',
      deptName: '证书管理部门',
      managementType: '管理类型',
      filter: '过滤器',
      certDefineType: '管理类型',
      certDefineCode: '管理编号',
      valid: '有效',
      sealed: '封存',
      dispOrder: '显示顺序',
      dispOrderOne: '显示顺序(清单)',
      dispOrderTwo: '显示顺序(一览表)',
      noData: '无数据',
      tableNo: '',
      vesselCode: '船舶编码',
      vesselName: '船名',
      certNo: '证书号',
      certName: '证书名称',
      certAlias: '别名',
      shortName: '简称',
      certNameCn: '证书名称(中文)',
      certNameEn: '证书名称(英文)',
      certCode: '证书编码',
      certGroup: '证书分组',
      certSubGroupOne: '证书子分组一',
      certSubGroupTwo: '证书子分组二',
      utn: 'UTN',
      certTerm: '证书周期',
      customType: '证书类型',
      vesselGroup: '适用船型',
      countryRequire: '适用国家或组织',
      criticalFlag: '是否关键证书',
      isSmallCert: '是否小证书',
      alertFlag: '是否需要提醒',
      preAlertDay: '提前提醒天数',
      certAt: ' 证书存放位置',
      issueBy: '签发单位',
      issueAt: '签发地点',
      issueDate: '签发日期',
      effectiveDate: '生效日期',
      expiryDate: '到期日期',
      extendedDate: '展期',
      certificateScan: '证书扫描件',
      lastSurveyDate: '上次检验/审核日期',
      planSurveyDate: '计划检验日期',
      surveyFlag: '需要检验/审核',
      certStatus: '证书状态',
      criticalCert: '关键证书',
      remark: '备注',
      yes: 'Y',
      no: 'N',
      certEditDate: '修改日期',
      certEditUser: '修改人',
      certEditContent: '修改内容',
      readStatus: '已阅状态',
      maintFlag: {
        title: '维护状态',
        na: '不适用',
        noCert: '证书未维护',
        noSurvey: '检验计划未维护',
        yes: '证书已维护',
        error: '数据错误',
        frontWarn: '进入检验窗口期',
        backWarn: '证书即将过期',
        overDue: '证书过期'
      }
    },
    checkRules: {
      certNo: '请填写证书号',
      issuedBy: '请填写签发单位',
      issuedAt: '请填写签发地点',
      issueDate: '请填写签发日期',
      dueDate: '请选择到期日期',
      certTerm: '请选择证书期限',
      certAt: '请选择证书存放位置',
      effectiveDate: '请选择生效日期',
      surveyRemark: '请填写检验描述',
      planSurveyDate: '请填写计划检验日期',
      checkVessel: '请先选择船舶',
      checkVesselAndCert: '请选择船舶和证书英文名称',
      checkCertName: '请填写证书名称',
      checkCompany: '请选择公司',
      checkCertDefineType: '请输入证书类型',
      checkCertDefineCode: '请输入管理编号',
      checkDeptId: '请选择主管部门',
      checkPostId: '请选择主管岗位',
      checkCertPeriod: '请选择证书周期',
      preAlertDay: '请填写提醒天数',
      writeCateId: '请填写证书号',
      setUnit: '请填写签发单位',
      setPlace: '请填写签发地点',
      surveyAt: '请填写检验地点',
      checkTackDate: '请选择签发日期',
      checkExpireDate: '请选择到期日期',
      setSavePlace: '请填写存放位置',
      surveyType: '请输入检验类型'
    },
    message: {
      sealedStatusTip: '封存状态下的证书不能进行该操作',
      checkSurveyListLength: '该证书需要添加检验/审核计划',
      checkTimeNoFrist: '所选时间不能早于签发日期!',
      checkVessel: '请先选择船舶',
      checkOnlyOneVessel: '只能选择一条船舶进行导出',
      unknownError: '未知错误',
      required: '请输入必填项',
      tips: '提示',
      deleteWarnTag: '是否确认删除该记录',
      confirm: '确认',
      cancel: '取消',
      deleteSuccess: '删除成功',
      deleteFail: '删除失败',
      deleteCancel: '已取消删除',
      confirmSeal: '是否确认封存证书',
      sealSuccess: '封存成功',
      sealFail: '处理失败',
      sealCancel: '已取消封存证书',
      checkIssuedDate: '签发日期不能晚于生效日期',
      checkEffectiveDate: '生效日期不能晚于到期日期',
      checkDueDate: '到期日期不能晚于展期',
      checkIssuedDueDate: '签发日期不能晚于到期日期',
      checkPlanSurveyDate1: '计划检验日期不能早于签发日期',
      checkPlanSurveyDate2: '计划检验日期不能早于窗口开始日期',
      checkPlanSurveyDate3: '计划检验日期不能晚于窗口结束日期',
      checkRangeStartDate: '窗口开始日期不能晚于窗口结束日期',
      checkExtendedDate: '展期不能早于窗口结束日期或计划检验日期',
      selectRenewalCert: '请选择换证证书',
      fullTermNotSupport: '永久证书暂不支持换证',
      exportFailed: '导出Excel失败',
      certOneLevel: '请先选择一级证书组',
      certTwoLevel: '请先选择二级证书组',
      getCertSurveyDefineFail: '查询证书检验要求失败',
      saveCertSurveyDefineSuccess: '保存检验要求成功',
      saveCertSurveyDefineFail: '保存检验要求失败',
      surveyDefineRepeat: '不能重复增加相同的检验要求',
      getCertDeptPostFail: '查询证书主管部门或岗位失败',
      saveCertDeptPostFail: '保存主管部门及岗位失败',
      getSurveyDefineListFail: '查询检验要求列表失败',
      saveCertDefineSuccess: '保存证书字典成功',
      saveCertDefineFail: '保存证书字典失败',
      getCertDefineFail: '查询证书字典错误',
      autoCreateSurveyFail: '自动生成检验列表失败',
      getCertInfoFail: '查询证书失败',
      saveCertInfoSuccess: '保存证书信息成功',
      saveCertInfoFail: '保存证书信息失败',
      saveSurveyDefineSuccess: '保存检验要求成功',
      getGroupFail: '查询证书组字典失败',
      getSurveyFail: '查询检验/审核信息失败',
      getSurveyListFail: '查询检验/审核列表失败',
      savedSurveySuccess: '保存检验/审核信息成功',
      savedSurveyFail: '保存检验/审核信息失败',
      getDefectFail: '查询缺陷信息失败',
      getDefectListFail: '查询缺陷列表失败',
      defectRequireWarn: '请输入缺陷描述',
      defectCloseWarn: '请输入缺陷关闭状态',
      defectLimitWarn: '请输入缺陷整改期限',
      savedDefectSuccess: '保存缺陷记录成功',
      savedDefectFail: '保存缺陷记录失败'
    },
    certInfo: {
      index: {
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '船舶证书维护'
        },
        filter: {
          all: '全部',
          inUse: '在用',
          invalid: '失效',
          sealed: '封存',
          noWarning: '未进窗口期',
          firstRange: '前半窗口期',
          secondRange: '后半窗口期',
          overdue: '过期',
          keyword: '关键字',
          keywordTag: '证书名称,别名,证书号',
          filter: '过滤器',
          certGroup: '证书组',
          certSubGroupOne: '证书子组一',
          certSubGroupTwo: '证书子组二'
        },
        button: {
          seal: '封存',
          renewal: '换证',
          createSurveyList: '生成检验列表',
          exportCertList: '导出列表',
          exportCertInfo: '导出证书一览表'
        }
      },
      form: {
        title: '证书信息',
        baseInfo: '基本信息',
        deptPostInfo: '证书主管部门',
        issueInfo: '证书签发信息',
        surveyInfo: '检验/审核信息',
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '船舶证书维护',
          menuFour: '检验维护',
          menuFive: '缺陷维护'
        },
        survey: {
          title: '检验/审核信息',
          baseInfo: '检验/审核信息',
          surveyRemark: '检验/审核描述',
          planSurveyDate: '计划检验/审核日期',
          rangeDate: '窗口期',
          rangeStartDate: '窗口开始日期',
          rangeEndDate: '窗口结束日期',
          surveyExtendedDate: '展期',
          surveyDate: '实际检验/审核日期',
          surveyAt: '检验/审核地点',
          surveyType: '检验/审核类型',
          breadcrumb: {
            surveyInfo: '检验信息',
            defectInfo: '缺陷信息'
          }
        },
        defect: {
          info: '缺陷记录',
          title: '缺陷信息',
          defectRecord: '缺陷记录',
          defectDesc: '缺陷描述',
          limitDate: '整改期限',
          preAlertDay: '提前提醒天数',
          defectStatus: '状态',
          defectOpen: '未关闭',
          defectClose: '已关闭'
        }
      },
      renewalForm: {
        title: '换证',
        baseInfo: '基本信息',
        oldCertInfo: '原证书',
        newCertInfo: '新证书'
      },
      btn: {
        record: '证书修改记录'
      }
    },
    certInfoEdit: {
      index: {
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '证书修改记录'
        },
        readStatus: {
          all: '全部',
          read: '已阅',
          toRead: '待阅'
        }
      },
      btn: {
        read: '阅毕'
      },
      read: {
        readDate: '阅读日期',
        readUser: '岸基主管'
      },
      title: '证书修改记录'
    },
    certDeptPost: {
      company: '管理公司',
      dept: '主管部门',
      post: '主管岗位'
    },
    certDefine: {
      index: {
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '船舶证书字典'
        },
        filter: {
          filter: '过滤器',
          certName: '证书名称',
          certGroup: '证书分组',
          certSubGroupOne: '证书子分组一',
          certSubGroupTwo: '证书子类型2',
          keyword: '关键字',
          keywordTag: '请输入证书名称、别名'
        }
      },
      form: {
        breadcrumb: {
          menuOne: '船舶证书管理',
          menuTwo: '船舶证书字典'
        },
        deptPostInfo: '证书主管部门',
        surveyInfo: '检验/审核要求',
        surveyNameCn: '检验/审核名称(中)',
        surveyNameEn: '检验/审核名称(英)',
        baseFlag: '计算基准',
        surveyPeriod: '检验/审核周期',
        rangeStartDay: '窗口开始规则',
        rangeEndDay: '窗口结束规则',
        month: '月',
        day: '天',
        effectiveDate: '生效日期',
        expiryDate: '到期日期',
        before: '前',
        after: '后',
        surveyType: '检验/审核类型'
      },
      title: '证书字典',
      certInfo: '证书信息',
      certOrg: '证书主管部门',
      certDefineVessel: '证书适用船舶',
      rules: {
        surveyNameCn: '请请填写中文名称',
        surveyNameEn: '请请填写英文名称',
        baseFlag: '请选择计算基准',
        surveyPeriod: '请填写检验/审核周期',
        reservedStr1: '请选择窗口规则',
        reservedStr2: '请选择窗口规则',
        surveyType: '请选择检验/审核类型',
        inputDays: '请输入天数'
      }
    },
    certMonitor: {
      index: {
        tip: '说明: 点击船名查看船舶证书维护情况明细',
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '证书维护情况监控'
        },
        company: '公司',
        lackCertFlag: '证书未维护',
        lackSurverFlag: '缺少检验',
        table: {
          vessel: '船舶',
          requireCertQty: '适用证书',
          criticalCertQty: '关键证书',
          expiredQty: '过期证书',
          beingExpiredQty: '即将过期证书',
          actualCertQty: '证书已维护',
          lackCertQty: '证书未维护',
          lackSurveyQty: '检验计划未维护证书',
          lackCertContent: '缺少证书名称',
          lackCertSurveyContent: '缺少检验计划的证书名称'
        }
      },
      certDefineVessel: {
        breadcrumb: {
          menuOne: '法定管理',
          menuTwo: '船舶证书管理',
          menuThree: '船舶证书维护情况'
        },
        manage: '船舶适用证书管理',
        title: '船舶证书监控',
        add: '增加',
        typeFlag: {
          allCert: '适用证书',
          criticalCert: '关键证书',
          expiredCert: '过期证书',
          beingExpired: '即将过期证书',
          inWindow: '进入检验窗口期',
          noCert: '未维护证书',
          noSurvey: '检验计划未维护证书',
          na: '不适用证书'
        }
      },
      certDefineSelect: {
        title: '船舶适用状态管理',
        status: '适用状态',
        message: {
          selectCert: '请先选择证书',
          addSuccess: '添加成功'
        }
      }
    }
  },
  surveyItem: {
    index: {
      noData: '无数据',
      tableNo: '序号',
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '检验管理',
        menuThree: '检验项目库',
        menuFour: '检验项目库维护'
      }
    },
    tabItem: {
      itemTitle: '检验项目库'
    },
    surveyType: {
      typeName: '检验项目分类',
      all: '全部',
      class: '适用船级社检验',
      unClass: '适用非船级社检验'
    },
    companyName: '所属公司',
    itemName: '检验项目',
    parentItem: '父项目',
    itemNameCn: '检验项目(中文)',
    itemNameEn: '检验项目(英文)',
    dispOrder: '显示顺序',
    itemUnit: '单位',
    itemRemark: '备注',
    isDelTips: '是否删除该项目？'
  },
  surveyApply: {
    breadcrumbTitle: {
      certificate: '船舶证书管理',
      survey: '船舶检验'
    },
    certificate: '船舶证书管理',
    filter: '过滤器',
    baseInfo: '基本信息',
    issuingInformation: '签发信息',
    certificateValidat: '证书检验/审核',
    title: {
      checkDate: '选择日期',
      apply: '申请',
      inquiry: '询报价',
      Price: '比价',
      Order: '下单',
      surveyManage: '检验管理',
      surveyApply: '检验申请',
      surveyInquiry: '检验询价',
      surveyPrice: '检验比价',
      surveyOrder: '检验定单',
      surveyTrack: '检验跟踪',
      company: '公司',
      vessels: '船舶',
      inspectionCategory: '检验类别',
      state: '状态',
      editTestProject: '编辑检验项目',
      addTestProject: '增加检验项目',
      surveyApplyInfo: '1.申请信息',
      surveyItem: '2.检验项目',
      fileList: '3.附件信息',
      approvalInfo: '4.审批信息'
    },
    btn: {
      syncToRFQ: '同步至询价',
      addition: '增加'
    },
    message: {
      checkRepairPlanDate: '请选择坞修计划',
      surveySubTypeNotEmpty: '请选择检验子类型',
      surveySubDeviceNotEmpty: '请选择设备',
      getGroupFail: '获取证书分组失败',
      obtainFail: '获取失败',
      getListFail: '获取检验/审核列表失败',
      informationSavedSuc: '检验/审核信息保存成功!',
      informationSavedFail: '保存检验/审核信息失败!',
      synchronizeToRFQ: '是否同步至询价',
      syncSuccess: '同步成功',
      syncFail: '同步失败',
      confirmSkip: '是否确认跳过船端审批',
      operateSucceeded: '操作成功',
      projectSaveSuc: '检验项目保存成功',
      projectSaveFail: '保存修理项目失败',
      projectApplySaveFail: '保存修理申请失败',
      deleteProjectSuc: '删除修理项目成功!',
      deleteProjectFail: '删除修理项目失败!',
      checkRepairPlan: '请增加检验项目',
      checkCertificateInformat: '请选择船舶证书检验信息',
      checkSurveyItemInformat: '请选择检验项目库信息',
      searchFail: '搜索失败',
      editSuc: '编辑成功',
      editFail: '编辑失败',
      checkVessel: '请选择船舶',
      checkVVL: '请选择船期',
      saveSuc: '保存成功',
      saveFail: '保存失败',
      getFail: '获取失败',
      rejectNode: '请选择驳回节点',
      rejectSuc: '驳回成功',
      rejectFail: '驳回失败',
      idRequisitionForm: '没有找到申请单id,请先保存再提交',
      emailSentSuc: '询价邮件发送成功!',
      deleteItem: '删除该项目也会删除该项目下所有子项目，是否删除该项目',
      confirmDeleteItem: '是否删除该项目',
      deleteCancel: '已取消删除',
      submittedSuc: '提交成功',
      submittedFail: '提交失败',
      deleteSuc: '删除成功',
      deleteFail: '删除失败',
      deleteCencel: '已取消删除',
      commitRecord: '是否确认提交该记录',
      deleteRecord: '是否确认删除该记录',
      tips: '提示',
      confirm: '确认',
      cancel: '取消',
      approvalOperation: '请选择审批操作',
      saveProjectSuc: '检验项目保存成功!',
      getInformationFail: '获取检验项目信息失败',
      saveInformationFail: '保存检验项目失败',
      inspectionItems: '请确认检验项目',
      certInfRelat: '自定义检验项目暂不关联证书信息！',
      pleaseSelectPlan: '请选择修理/检验计划'
    },
    index: {
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '船舶检验申请'
      },
      filter: {
        ship: '船舶',
        applyCode: '申请单号',
        surveyType: '检验类别'
      },
      filterTab: {
        all: '全部',
        draft: '草稿',
        onApproval: '审批中',
        finishApproval: '审批完成'
      },
      button: {
        add: '新增',
        archive: '归档',
        applySurvey: '申请检验',
        export: '导出'
      },
      table: {
        ship: '船舶',
        vesselCode: '船舶编码',
        applyCode: '申请单号',
        surveyType: '检验类别',
        planSurveyDate: '计划检验日期',
        shoreFlag: '申请来源',
        applyPerson: '申请人',
        applyDate: '申请日期',
        status: '状态'
      }
    },
    buttons: {
      save: '保存',
      submit: '提交',
      inquiryMail: '发起询价',
      fileUpload: '上传附件',
      skipShipApproval: '跳过船端审批'
    },
    editApply: {
      surveySubType: '检验子类型',
      surveySubDevice: '设备',
      title: {
        certificateInformat: '船舶证书信息',
        inspectInformat: '检验/审核信息',
        editInformat: '编辑检验/审核信息',
        addInformat: '增加检验/审核信息',
        getFail: '获取失败',
        informationSavedSuc: '检验/审核信息保存成功!',
        informationSavedFail: '保存检验/审核信息失败!',
        certificateClass: '证书类型',
        certificateOne: '证书子类型1',
        certificateTwo: '证书子类型2',
        certificateDate: '证书周期',
        certificateDateOne: '证书周期1',
        certificateDateTwo: '证书周期2',
        operation: '操作'
      },
      reset: '重置',
      vesselCert: '船舶证书',
      inspectionItems: '自定义检验项目',
      detailTile: '申请明细',
      repairItemTile: '检验项目',
      attachmentTitle: '附件信息',
      certName: '证书名称',
      button: {
        addSurveyItem: '增加检验项目',
        addChildItem: '增加子项目'
      },
      itemTab: {
        vesselCertItem: '船舶证书项目',
        customItem: '自定义项目'
      },
      surveyApplyId: '申请单主键ID',
      vesselCode: '船舶',
      applyCode: '申请单号',
      surveyType: '检验类别',
      planSurveyDate: '计划检验日期',
      lastSurveyDate: '上次检验日期',
      lateSurveyDate: '中检最晚日期',
      lateSpecialSurveyDate: '特检最晚日期',
      planSurveyPort: '计划检验地点',
      estArriveTime: '预计抵达时间',
      estleaveTime: '预计离开时间',
      dockPlan: '坞修计划',
      technicalFlag: '技改',
      applyPerson: '申请人',
      applyDate: '申请日期',
      applyRemark: '备注 ',
      itemForm: {
        mainItemId: '主修理项目编号',
        mainItemName: '主修理项目名称',
        itemCode: '修理项目编号',
        itemParentCode: '父项目编号',
        selectRepairItem: '选择修理项目',
        repairItemLibrary: '修理项目库',
        custom: '自定义',
        itemContent: '项目内容',
        itemAmount: '数量',
        itemUnit: '单位',
        dsDueDate: '检验日期',
        ssDueDate: '检验到期日',
        lsDueDate: '上次检验日期',
        itemPosition: '位置',
        technicalFlag: '技改项',
        insuranceFlag: '保险索赔',
        itemRemark: '其他说明',
        devInfoId: '设备ID',
        devName: '设备名称',
        devModel: '设备型号',
        relatedDevice: '关联设备',
        cancelRelated: '取消关联',
        devVendorName: '设备供应商',
        lastOperator: '最后操作人',
        lastDate: '最后操作时间',
        shoreFlag: '岸基增加标志',
        approvalFlag: '岸基审批标志'
      },
      projectTable: {
        itemCode: '项目编号',
        itemName: '项目名称'
      },
      itemTable: {
        surveyContent: '检验内容',
        mainConfirm: '总管确认',
        dueDate: '到期日期/窗口期',
        itemAmount: '数量',
        itemUnit: '单位',
        devInfoId: '设备ID',
        devName: '设备名称',
        devModel: '设备型号',
        itemRemark: '其他说明',
        lastSurveyDate: '上次检验日期',
        windowPeriod: '窗口期',
        dsDueDate: '中检最晚日期',
        ssDueDate: '特检最晚日期',
        insuranceFlag: '保险索赔',
        safetyFlag: '安全费用',
        technicalFlag: '技改项',
        addPerson: '添加人',
        addDate: '添加日期'
      },
      certTable: {
        vessel: '船舶',
        certName: '证书名称',
        certNo: '证书编号',
        surveyContent: '检验内容',
        issuedDate: '签发日期',
        effectivedate: '生效日期',
        dueDate: '失效日期',
        lastSurveyDate: '上次检验日期',
        nextSurveyDate: '下次检验日期',
        rangeStartDate: '窗口开始时间',
        rangeEndDate: '窗口结束时间',
        extendedDate: '窗口期'
      },
      devTable: {
        devName: '设备名称',
        devModel: '设备型号',
        devManufacturer: '设备厂商'
      }
    },
    checkRules: {
      itemContent: '请填写项目内容',
      itemQuantity: '请填写数量'
    },
    form: {
      checkingInformation: '检验/审核信息',
      surveyRemark: '检验/审核描述',
      planSurveyDate: '计划检验/审核日期',
      rangeDate: '窗口期',
      rangeStartDate: '窗口开始日期',
      rangeEndDate: '窗口结束日期',
      surveyExtendedDate: '展期',
      surveyDate: '实际检验/审核日期',
      surveyAt: '检验/审核地点'
    },
    defectTable: {
      flawInfo: '缺陷信息',
      flawRecord: '缺陷记录',
      defectDesc: '缺陷描述',
      limitDate: '整改期限',
      preAlertDay: '提前提醒天数',
      defectStatus: '状态'
    },
    defectForm: {
      defectDesc: '缺陷描述',
      limitDate: '整改期限',
      preAlertDay: '提前提醒天数',
      defectStatus: '状态'
    },
    defectStatus: {
      on: '开启',
      off: '关闭'
    },
    certForm: {
      certCategory: '证书类别',
      oldBooks: '旧证书',
      newBooks: '新证书',
      vessel: '船舶',
      certNameEn: '证书英文名称',
      department: '主管部门',
      post: '主管岗位',
      shortName: '证书简称',
      certNameCn: '证书中文名称',
      jobs: '主管岗位',
      certGroup: '证书类型',
      certSubGroup1: '证书子类型1',
      certSubGroup2: '证书子类型2',
      effective: '是否有效',
      countryRequire: '适用国家/组织要求',
      vesselTeamId: '适用船型',
      smallFlag: '小证书',
      alias: '证书别名',
      certNo: '证书编号',
      utn: 'UTN (电子证书编号)',
      issueBy: '签发单位',
      issueAt: '签发地点',
      issueDate: '签发日期',
      effectiveDate: '生效日期',
      expiryDate: '到期日期',
      extended: '展期',
      certTerm: '证书周期',
      alertFlag: '是否提醒',
      preAlertDay: '提前提醒天数',
      certAt: '存放位置',
      memo: '备注'
    },
    surveyTable: {
      surveyRemark: '检验/审核描述',
      planSurveyDate: '计划检验/审核日期',
      rangeDate: '窗口期',
      rangeStartDate: '窗口开始日期',
      rangeEndDate: '窗口结束日期',
      surveyExtendedDate: '展期',
      surveyDate: '实际检验/审核日期',
      surveyAt: '检验/审核地点',
      defectStatus: '缺陷状态',
      annualSurvey: '是否结合中间审核'
    }
  },
  surveyInquiry: {
    breadcrumbTitle: {
      certificate: '船舶证书管理'
    },
    certificate: '船舶证书管理',
    filter: '过滤器:',
    setkeyword: '请输入关键字',
    keyword: '关键字检索',
    apply: {
      poss: '通过',
      reject: '驳回',
      totalAmount: '总金额:',
      totalAmountOne: '1、当总金额 <= 3,000 USD 时，需要机务监督、机务副总经理。',
      totalAmountTwo: '2、当总金额 >  3,000 USD 时，需要公司机务总经理审批。',
      totalAmountThree: '3、当总金额 >  20,000 USD 时，需要公司总经理助理、公司副总经理审批。',
      totalAmountFour: '4、当总金额 >  50,000 USD 时，需要公司总经理审批。',
      totalAmountOneCny: '1、当总金额 <= 18,000 CNY 时，需要机务监督、机务副总经理。',
      totalAmountTwoCny: '2、当总金额 >  18,000 CNY 时，需要公司机务总经理审批。',
      totalAmountThreeCny: '3、当总金额 >  120,000 CNY 时，需要公司总经理助理、公司副总经理审批。',
      totalAmountFourCny: '4、当总金额 >  300,000 CNY 时，需要公司总经理审批。',
      keyWordFilter: '可查询申请单号、设备名称',
      keyWordFilterParts: '可查询备件名称、备件号',
      purchaseManage: '采购管理',
      spareApply: '备件采购',
      vesselName: '船名',
      dept: '部门',
      applyNo: '申请单号',
      devName: '设备名称',
      applyPurpose: '使用目的',
      urgencyVessel: '紧急程度',
      urgencyShore: '紧急程度(岸端)',
      applyDate: '申请日期',
      processNodeShow: '当前进度',
      option: '操作',
      noOrdered: '未下单',
      ordered: '已下单',
      canceled: '已作废',
      all: '全部',
      spare: '备件',
      inquiry: '询价',
      devCode: '设备编码',
      devModel: '设备型号',
      devSerialNo: '设备序列号',
      devMaker: '设备厂家',
      applyReason: '申请理由',
      etp: '预计收货港口',
      applyStatus: '状态',
      electrical: '电气类',
      applicant: '申请人',
      equipmentType: '设备类别',
      transferStatus: '调拨标识',
      transferNo: '调拨单号',
      receiveDate: '接收时间(岸端)',
      enquireStatus: '询价标识',
      memo: '申请说明/联系方式',
      remark: '备注',
      tempSaveNum: '暂存项目数量',
      spareInquiry: '备件询报价',
      SendInquiry: '发起询价',
      chooseInquirySupplier: '选择询价供应商',
      historSuppliers: '历史采购供应商',
      supplier: '供应商',
      sender: '发件人',
      receiver: '收件人',
      copyTo: '抄送',
      theme: '主题',
      emailContent: '邮件内容',
      file: '附件',
      confirm: '确认',
      eta: '预计抵港时间',
      etd: '预计离港时间',
      tables: {
        seqNo: '顺序码',
        applyQty: '申请数量',
        centralized: '集采项目',
        inquiryQty: '询价数量',
        sendAttach: '发送图纸',
        partsName: '备件名称',
        partsCode: '备件号',
        partsDrawing: '图纸号',
        drawingItem: '在图号',
        unit: '单位',
        stockQty: '当前库存',
        unOrderQty: '已申请未下单数量',
        unReceiveQty: '已下单未签收数量',
        minStockQty: '安全库存',
        poQty: '定单数量',
        canTransferQty: '可调拨库存',
        transferQty: '已调拨数量',
        toTransferQty: '调拨数量',
        applyRemark: '申请备注',
        partsRemark: '备件备注',
        hcbCode: '航筹办代码',
        ripCode: '供应商代码',
        ripName: '供应商名称',
        ripNameEn: '供应商名称(英文)',
        ripEmail: '邮件地址',
        contacts: '联系人',
        email1: '邮件地址1',
        email2: '邮件地址2',
        email3: '邮件地址3',
        fileName: '附件名称'
      },
      tips: {
        sparePartsInfo: '备件信息',
        colorTips: '色数字：申请数量与定单数量不一致',
        applyInfo: '申请信息',
        partsInfo: '备件信息',
        attachment: '附件信息',
        approveHistory: '审批历史',
        commonPurchase: '普通采购',
        addSpareTip: '如需添加备件，请通知岸基人员添加'
      },
      buttons: {
        temporary: '暂存',
        invalid: '作废',
        inquiryMail: '发起询价',
        transferApply: '生成调拨单',
        selectParts: '选择申请备件',
        fileUpload: '上传附件'
      }
    },
    editApply: {
      priceOpinions: '比价意见',
      supplier: '供应商',
      repairItemTile: '检验项目'
    },
    message: {
      checkInquirySupplier: '请选择供应商',
      deleteInquiry: '是否确认删除该条询价',
      tips: '提示',
      confirm: '确定',
      cancel: '取消',
      deleteRecord: '是否确认删除该记录',
      submitRecord: '是否确认提交该记录',
      submitSuc: '提交成功',
      submitFail: '提交失败',
      rejectNode: '请选择驳回节点',
      rejectSuc: '驳回成功',
      rejectFail: '驳回失败',
      delete: '删除成功',
      deleteFail: '删除失败',
      deleteCancel: '已取消删除',
      submitInquirySuc: '比价提交成功',
      submitInquiryFail: '比价提交失败',
      gainFail: '获取失败',
      searchFail: '搜索失败',
      offerSaveSuc: '询报价保存成功',
      offerSaveFail: '询报价保存失败',
      exchangeRateNoresults: '该币种查询汇率无结果',
      mailSendSuc: '询价邮件发送成功!',
      cancelComparison: '是否取消比价重新报价',
      getInformationFail: '获取比价信息失败',
      saveProjectsuc: '修理项目保存成功!',
      saveProjectFail: '保存修理项目失败',
      submitPriceSuc: '比价提交成功',
      submitPriceFail: '比价提交失败',
      checkSupplier: '请选择询价供应商',
      checkComparisonItems: '未选择检验比价项目，请选择比价项目',
      mustOneSupplierOffer: '至少有一家供应商报价才能提交比价!',
      checkApproval: '请选择审批操作！'
    },
    content: {
      inquiryList: '1.询价单列表',
      inquiryInfo: '2.询价单信息',
      supplierInfo: '3.服务商报价信息',
      repairItem: '4.检验项目报价信息',
      mailSendLog: '5.邮件发送日志',
      fileList: '6.附件信息',
      inquiryWorkflow: '7.历史审批意见',
      priceComparison: '1.比价信息',
      comparisonItem: '2.检验项目对比',
      approvalInfo: '3.审批信息'
    },
    orderEmailDialog: {
      statutoryManagement: '法定管理',
      orderManagement: '定单管理',
      sendOrderEmail: '发送下单邮件'
    },
    breadcrumb: {
      menuOne: '法定管理',
      menuTwo: '检验询价',
      menuThree: '选择供应商'
    },
    buttons: {
      save: '保存',
      submit: '提交',
      compareSubmit: '比价提交',
      cancelCompare: '取消比价',
      compareExport: '导出比价',
      inquiryMail: '发起询价',
      fileUpload: '上传附件'
    },
    index: {
      priceList: '询价列表',
      title: '',
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '检验询价'
      },
      filter: {
        ship: '船舶',
        applyCode: '申请单号',
        repairType: '修理类别'
      },
      filterTab: {
        all: '全部',
        toInquiry: '待询价',
        onApproval: '询价中',
        finished: '已完成',
        cancel: '已取消',
        finishApproval: '比价审批完成'
      },
      table: {
        dictionary: {
          docking: '坞修',
          voyageRepair: '航修',
          dockingSon: '坞修子合同',
          all: '全部',
          draft: '待下单',
          onApproval: '审批中',
          finishApproval: '审批完成',
          cancel: '取消',
          shore: '岸基发起',
          ship: '船端发起'
        },
        inquiryCode: '询价单号',
        vesselCode: '船舶',
        repairApplyId: '申请单主键ID',
        applyCode: '申请单编号',
        repairType: '修理类别',
        electricFlag: '电气类',
        shoreFlag: '申请来源',
        applyPerson: '申请人',
        applyDate: '申请日期',
        inquiryStatus: '状态'
      }
    },
    editInquiry: {
      dialogTitle: '询价详细',
      repairItemTile: '检验项目报价信息',
      inquiryTable: {
        inquiryCode: '询价单号',
        inquiryStatus: '状态',
        supplierName: '检验单位',
        quotePrice: '报价总价',
        currencyCode: '币种',
        currencyRate: '汇率',
        discount: '折扣(%)',
        priceAfterDiscount: '折后总价',
        estStartDate: '预计开始日期',
        estSurveyDays: '预计检验天数',
        status: '状态'
      },
      inquiryForm: {
        inquiryInfo: '询价单信息',
        serviceInfo: '服务商报价信息',
        vessel: '船舶',
        inquiryCode: '询价单号',
        inquiryStatus: '询价状态',
        surveyType: '检验类别',
        technicalFlag: '技改',
        planSurveyDate: '计划检验日期',
        currencyLocal: '本位币种',
        planSurveyPort: '计划检验地点',
        supplierName: '询价厂商',
        inquiryRemark: '备注'
      },
      quoteForm: {
        taxRate: '税率(%)',
        taxAmount: '税金',
        quoteNo: '报价号',
        quoteDate: '报价日期',
        surveyPort: '检验地点',
        currencyCode: '币种',
        currencyRate: '汇率',
        quotePrice: '报价总价',
        quoteDiscount: '总价折扣(%)',
        priceAfterDiscount: '折后总价',
        estStartDate: '预计检验开始日期',
        realStartDate: '实际检验开始日期',
        estEndDate: '预计检验完工日期',
        realEndDate: '实际检验完工日期',
        estWorkDays: '预计工作天数',
        realWorkDays: '实际工作天数',
        supplierRemark: '厂商备注'
      },
      itemTable: {
        surveyContent: '检验内容',
        mainConfirm: '总管确认',
        dueDate: '到期日期/窗口期',
        devName: '关联设备',
        devModel: '设备型号',
        itemRemark: '其他说明',
        itemAmount: '数量',
        itemUnit: '单位',
        unitPrice: '单价',
        singleDiscount: '单项折扣(%)',
        discountedAmount: '折后金额',
        quoteInstruction: '报价说明'
      }
    },
    compare: {
      common: {
        yes: '是',
        no: '否',
        false: '有效',
        true: '无效',
        safetyCost: '安全生产费',
        safetyFlag: '包含安全生产费',
        safetyCharge: '安全生产费分类',
        safetyReviewStatus: '安全生产费复核状态',
        evalAmount: '预估金额',
        message: {
          updateSuc: '更新成功',
          updateFail: '更新失败'
        }
      },
      message: {
        checkSafeFlag: '请选择是否包含安全生产费',
        checkSafeCharge: '包含安全生产费时，必须有一项修理项勾选安全生产费且选择了具体安全生产费分类',
        verifyCheck: '不包含安全生产费时，修理项目不能存在已勾选安全生产费',
        checkItemSafeFlag: '请选择安全生产费分类',
        changeChargeTip: '更换业务科目时会根据业务科目配置信息，重新分配安全生产费类别，已选择安全生产费类别会被覆盖，请注意！'
      },
      compareExport: '导出比价',
      qtaAttachment: '报价附件',
      budget: '科目预算',
      chargeId: '科目名称',
      baPercentage: '预算金额百分比',
      auditAmount: '审批中金额',
      bRemainingAmount: '预算剩余金额',
      quoteTable: {
        taxRate: '税率(%)',
        taxAmount: '税金',
        supplier: '供应商',
        totalAmount: '总报价',
        currency: '币种',
        discount: '总价折扣',
        disAmount: '折后金额',
        disAmountUSD: '折后金额(USD)',
        projectAmount: '选中项目总金额',
        thisTotalAmount: '此次比价总金额',
        estWorkDays: '预计工作天数',
        compareFigure: '对比图'
      },
      itemTable: {
        specialSign: '特殊标识',
        surveyContent: '检验内容',
        applyAmount: '申请数量',
        amount: '数量',
        unit: '单位',
        select: '选择',
        insuranceFlag: '保险索赔',
        safetyCostFlag: '安全费用',
        technicalFlag: '技改项',
        inquiryPrice: '单价',
        inquiryDiscount: '折扣(%)',
        discountPrice: '折后单价',
        LowestDiscountPrice: '最低折后单价',
        totalPriceAfter: '折后总价',
        quoteRemark: '报价说明'
      },
      msg: {
        checkTip: '请先勾选此供应商'
      }
    },
    checkRules: {
      checkVessel: '请选择船舶',
      messageCheck: '不能超过100个字符',
      checkMoney: '请选择币种',
      effectiveDate: '请选择日期',
      placeSetDate: '请输入天数',
      taxRateCode: '请选择税率',
      estSurveyStartDate: '请选择预计检验开始日期',
      estSurveyEndDate: '请选择预计检验完工日期'
    }
  },
  surveyOrder: {
    reInquiry: {
      tip: '当有多个检验定单时,重新询价后。所有检验定单都会取消下单'
    },
    breadcrumbTitle: {
      survey: '船舶检验'
    },
    filter: '过滤器',
    message: {
      selectOrder: '请选择需要废弃的定单',
      delChild: '删除该项目也会删除该项目下所有子项目，是否删除该项目',
      getFail: '获取失败',
      getOrderListFail: '获取定单列表失败',
      searchFail: '搜索失败',
      saveSuc: '保存成功',
      saveFail: '保存失败',
      checkoutSuc: '下单成功！',
      checkoutFail: '下单失败！',
      emailSentSuc: '下单邮件发送成功!',
      emailSentFail: '下单邮件发送失败!',
      orderCancelledSuc: '取消定单成功！',
      orderCancelledFail: '取消定单失败！',
      chargeNameCn: '请选择业务科目',
      inquiryPage: '跳转询价页面！',
      cancelOrderFail: '取消定单失败!',
      cancelOrder: '是否取消该检验定单',
      suc: '成功',
      delete: '删除成功',
      deleteFail: '删除失败',
      deleteCancel: '已取消删除',
      canceledOrder: '已取消下单',
      deleteRecord: '是否确认删除该记录',
      confirmOrder: '是否确认下单',
      tips: '提示',
      confirm: '确认',
      cancel: '取消'
    },
    content: {
      surveyOrderList: '1.定单列表',
      orderInfo: '2.定单信息',
      surveyItem: '3.检验项目',
      mailSendLog: '4.邮件发送日志',
      fileList: '5.附件'
    },
    title: {
      company: '公司',
      vessel: '船舶',
      inspectionCategory: '检验类别',
      state: '状态'
    },
    span: {
      orderList: '定单列表'
    },
    buttons: {
      save: '保存',
      orderEmail: '下单邮件发送',
      order: '确认下单',
      cancelOrder: '取消下单',
      fileUpload: '上传附件'
    },
    index: {
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '检验定单'
      },
      filter: {
        vessel: '船舶'
      },
      filterTab: {
        all: '全部',
        warning: '预警中',
        expired: '已过期'
      },
      button: {
        add: '新增'
      },
      table: {
        vessel: '船舶',
        vesselCode: '船舶编码',
        orderCode: '定单号',
        surveyType: '检验类别',
        surveyCompany: '检验单位',
        surveyPort: '检验地点',
        estStartDate: '预计开始日期',
        realStartDate: '实际开始日期',
        estEndDate: '预计结束日期',
        orderDate: '下单日期',
        endTime: '完工日期',
        realEndDate: '实际结束日期',
        estSurveyDays: '预计检验天数',
        realSurveyDays: '实际检验天数',
        orderStatus: '状态',
        totalOrderAmount: '定单总额',
        orderCurrency: '定单币种',
        orderDiscount: '总价折扣(%)',
        discountAmount: '折后金额',
        orderAmountUSD: '定单总额(USD)',
        paymentStatus: '付款状态',
        unpay: '未付款',
        paying: '付款中',
        paiedPartial: '部分付款',
        paiedALL: '已付清'
      }
    },
    editOrder: {
      orderInfo: '定单信息',
      surveyItem: '检验项目',
      orderTable: {
        orderCode: '定单号',
        surveyCompany: '检验单位',
        totalQuotePrice: '总报价',
        currencyCode: '币种',
        discount: '总价折扣(%)',
        currencyRate: '汇率',
        priceAfterDiscount: '折后总价',
        estStartDate: '预计检验开始日期',
        estSurveyDays: '预计检验天数',
        status: '状态'
      },
      orderForm: {
        projectSubject: '工程摘要',
        vessel: '船舶',
        orderCode: '定单号',
        orderDate: '下单日期',
        surveyType: '检验类别',
        technicalFlag: '技改',
        dockType: '坞修计划',
        surveyCompany: '检验单位',
        surveyProt: '检验地点',
        estStartDate: '预计检验开始日期',
        realStartDate: '实际检验开始日期',
        estEndDate: '预计检验完工日期',
        realEndDate: '实际检验完工日期',
        realTestDate: '实际检验天数',
        testPlace: '检验地点',
        estSurveyDays: '预计检验天数',
        realSurveyDays: '实际检验天数',
        currencyCode: '币种',
        currencyRate: '汇率',
        totalQuotePrice: '总价',
        totalAmountUSD: '总价(USD)',
        totalDiscount: '总价折扣(%)',
        discountedAmount: '折后总价',
        taxRate: '税率%',
        taxAmount: '税金',
        payStatus: '付款状态',
        budgetId: '业务科目',
        cav: '特殊业务标记',
        costSource: '费用管理模式',
        orderStatus: '定单状态',
        orderRemark: '备注'
      },
      itemTable: {
        surveyContent: '检验内容',
        dueDate: '到期日期/窗口期',
        devName: '关联设备',
        devModel: '设备型号',
        itemRemark: '其他说明',
        itemAmount: '数量',
        itemUnit: '单位',
        unitPrice: '单价',
        discount: '折扣(%)',
        discountedAmount: '折后金额',
        quoteInstruction: '报价说明',
        specialSign: '特殊标识',
        claimFlag: '是否索赔'
      }
    },
    checkRules: {
      checkVessel: '请选择船舶',
      orderCode: '请填写定单号',
      taxRate: '请填写税率',
      chargeNameCn: '请选择业务科目',
      expenseSource: '请选择费用管理模式',
      expenseDeptId: '请选择费用所属部门'
    }
  },
  surveyComplete: {
    breadcrumbTitle: {
      regulation: '法规跟踪'
    },
    message: {
      supplierRating: '请先完成供应商评分',
      allFinish: '所有项目是否完成？',
      tips: '提示',
      confirm: '确定',
      cancel: '取消',
      surveyStatus: '所有项目验收确认才能岸端确认完工',
      completeQty: '检验通过的项目，完工数量不能小于0',
      submitConfirm: '所有项目岸端确认才能岸端确认完工',
      loginFail: '登录已失效，请重新登录。',
      saveSuc: '保存成功',
      saveFail: '保存失败',
      getFail: '获取失败',
      geiListFail: '获取定单列表失败',
      specialSigns: '特殊标识'
    },
    buttons: {
      save: '保存',
      shipComplete: '完工确认(船端)',
      shoreComplete: '完工确认(岸端)',
      supplierRating: '供应商评分',
      fileUpload: '上传附件',
      cancelOrder: '取消定单'
    },
    additionalProject: '追加检验项目',
    surveyComplete: '检验完工',
    completeInfo: '完工信息',
    acceptanceItem: '检验验收项目',
    completeForm: {
      behalfPayFlag: '代付类型',
      behalfPayAmount: '代付金额',
      taxRate: '税率(%)',
      taxAmount: '定单税金',
      shipyardInfo: '服务商信息',
      addMoney: '追加总金额',
      vesselName: '船舶名称',
      supplierRating: '供应商评分',
      supplierName: '供应商名称:',
      businessOrder: '业务单号:',
      vessels: '船舶:',
      afterService: '售后服务:',
      offerTimely: '报价及时性:',
      priceReason: '价格合理性:',
      quality: '货物/工作质量:',
      distribution: '备货/配送及时性:',
      averageScore: '总分:',
      remark: '备注:',
      surveyOrderList: '1.定单列表',
      surveyInfo: '2.定单信息',
      surveyItem: '3.检验项目',
      fileList: '4.附件信息',
      vessel: '船舶',
      orderCode: '定单号',
      orderStatus: '定单状态',
      surveyType: '检验类别',
      technicalFlag: '技改',
      estStartDate: '计划开始日期',
      estEndDate: '计划结束日期',
      estSurveyDays: '预计检验天数',
      budgetId: '业务科目',
      cav: '特殊业务标记',
      costSource: '费用管理模式',
      payStatus: '付款状态',
      dockType: '坞修计划',
      orderPrice: '定单总额',
      completeAmount: '完工金额',
      creditAmount: '减免金额',
      amountPayable: '应付金额',
      currencyCode: '币种',
      currencyRate: '汇率',
      totalPriceDiscount: '总价折扣(%)',
      discountFinishAmount: '折后应付金额',
      orderAndAddTotalAmount: '定单和追加总金额',
      shouldPayAftDisTaxAmount: '应付税金',
      shouldPayAftDisTaxAmountLocal: '应付税金(本位币)',
      discountedAmount: '折后应付金额(USD)',
      surveyCompany: '检验单位',
      surveyProt: '检验地点',
      linkMan: '联系人'
    },
    acceptanceTable: {
      surveyContent: '检验内容',
      dueDate: '到期日期/窗口期',
      devName: '关联设备',
      devModel: '设备型号',
      acceptanceFlag: '验收确认',
      itemAmount: '完工数量',
      itemUnit: '单位',
      unitPrice: '单价',
      discount: '折扣(%)',
      shoreSure: '岸端确认',
      shoreRemark: '岸端备注',
      vesselRemark: '船端备注',
      discountedAmount: '完工金额',
      quoteInstruction: '报价说明',
      claimFlag: '是否索赔'
    },
    addToItem: {
      span: {
        addList: '追加检验定单',
        addMoney: '追加总金额'
      },
      repairItem: '修理项目',
      addTable: {
        addToBatchNo: '追加批次号',
        totalAmount: '总金额',
        discount: '总价折扣(%)',
        totalAmountAfDis: '折后总金额',
        totalAmountUSD: '总金额(USD)',
        additionalPeople: '追加人',
        additionalDate: '追加日期',
        status: '状态'
      },
      addOrderForm: {
        choiceDate: '选择日期',
        vesselCode: '船舶',
        orderCode: '批次号',
        orderStatus: '状态',
        creator: '追加人',
        createDate: '追加日期',
        currencyId: '币种',
        currencyRate: '汇率',
        orderPrice: '总价',
        orderDiscount: '总价折扣(%)',
        finishAmount: '折后总价',
        orderRemark: '备注'
      }
    },
    checkRules: {
      itemContent: '请填写项目内容',
      itemQuantity: '请填写数量',
      surveyDateStart: '请选择检验开始日期',
      surveyDateEnd: '请选择检验完工日期',
      surveyAt: '请填写检验地点'
    }
  },
  statutoryChange: {
    breadcrumbTitle: {
      regulation: '法规跟踪'
    },
    setkeyword: '请输入关键字',
    title: {
      personCharge: '责任人',
      specialSign: '特殊标识'
    },
    label: {
      statuteNames: '法规名称',
      keyword: '关键字'
    },
    message: {
      note: '备注: 所选管理公司暂不支持启动变更',
      saveSuc: '保存成功',
      saveFail: '保存失败',
      getFail: '获取失败',
      submitSucc: '提交成功',
      submitFail: '提交失败',
      taskIsnull: '变更任务未分配，是否继续提交',
      changeFalseAndTaskNull: '未分配任务，是否继续提交',
      checkCompany: '请先添加适用公司',
      searchFailed: '搜索失败',
      SaveBeforeAdding: '请先保存再增加',
      delete: '删除成功',
      deleteFail: '删除失败',
      deleteCancel: '已取消删除',
      deleteRecord: '是否确认删除该记录',
      changeFail: '获取法定变更失败',
      taskQueryFail: '查询任务信息失败',
      vesselsNotEmpty: '请选择船舶',
      testClassNotEmpty: '请选择检验类别',
      testDateNotEmpty: '请选择计划检验日期',
      tips: '提示',
      confirm: '确定',
      cancel: '取消',
      getEnddateFail: '截止日期不能早于当前日期'
    },
    span: {
      statutoryChangeInforma: '法定变更信息'
    },
    content: {
      statutoryChange: '1.法定变更信息',
      statutoryFile: '2.法规附件',
      taskInfo: '3.任务信息',
      taskFeedback: '4.任务反馈',
      taskFile: '5.任务附件'
    },
    index: {
      breadcrumb: {
        menuOne: '法定管理',
        menuTwo: '法规跟踪'
      },
      filter: {
        ship: '',
        repairType: ''
      },
      filterTab: {
        all: '全部',
        unfinished: '未完成',
        finished: '已完成'
      },
      button: {
        add: '新增'
      },
      table: {
        regulationStatus: '法规状态',
        statutoryName: '法规名称',
        statutorySources: '法规来源',
        statutoryAbstract: '法规信息摘要',
        initiationDate: '拟发起日期',
        effectiveDate: '生效日期',
        taskProgress: '任务完成情况',
        status: '状态',
        inputPerson: '录入人',
        inputDate: '录入日期',
        setChangeManage: '是否发起变更管理',
        applyNo: '申请编号',
        changeManagePerson: '变更管理发起人'
      }
    },
    editStatutory: {
      statutoryChangeInfo: '法规跟踪信息',
      dialogTitle: '法规跟踪',
      applicableCompany: '适用公司',
      company: '公司',
      statutoryForm: {
        company: '管理公司',
        yes: '是',
        no: '否',
        statutoryName: '法规名称',
        inputPerson: '录入人',
        inputDate: '录入日期',
        statutorySources: '法规来源',
        statutoryAbstract: '法规信息摘要',
        effectiveDate: '生效日期',
        changeFlag: '是否启动变更管理',
        status: '状态',
        initiator: '发起人',
        initiationDate: '变更发起日期',
        draftDate: '拟发起日期',
        mocRemark: '变更理由及描述'
      },
      fileTable: {
        fileName: '附件名称',
        uploadPerson: '上传人',
        uploadDate: '上传日期',
        remark: '备注'
      },
      taskTable: {
        taskContent: '任务描述',
        taskPerson: '责任人',
        initiationDate: '发起日期',
        endDate: '截止日期',
        taskStatus: '状态',
        taskRemark: '备注'
      }
    },
    taskInfo: {
      dialogTitle: '任务信息',
      taskContent: '任务描述',
      taskPerson: '责任人',
      endDate: '截止日期',
      taskRemark: '备注'
    },
    checkRules: {
      changeFlag: '请选择是否启动变更管理',
      company: '请选择管理公司',
      statutoryName: '请输入法规名称',
      statutorySource: '请输入法规来源',
      effectiveDate: '请选择日期',
      mocUserName: '请选择发起人',
      mocPlanDate: '请选择拟发起日期',
      taskContent: '请输入任务描述',
      userCodeList: '请选择责任人',
      TaskCompletion: '请输入任务完成情况'
    }
  },
  taskFeedback: {
    breadcrumbTitle: {
      regulation: '法规跟踪'
    },
    message: {
      searchFailed: '搜索失败'
    },
    label: {
      all: '全部',
      notFinished: '未完成',
      finished: '已完成',
      keyword: '关键字',
      include: '责任人/法规名称/任务描述'
    },
    title: {
      shipName: '船名',
      applyDate: '申领日期',
      today: '今天',
      week: '一周',
      mounth: '一月内',
      year: '一年内'
    },
    breadcrumb: {
      menuOne: '法定管理',
      menuTwo: '任务跟踪'
    },
    index: {
      table: {
        statutoryName: '法规名称',
        taskContent: '任务描述',
        employeeNameEn: '责任人',
        initiationDate: '发起日期',
        rangeDateEnd: '计划截止日期',
        completeStatus: '状态',
        completeContent: '任务完成情况',
        completeRemark: '备注'
      }
    },
    feedbackTracking: {
      trackingDetails: '跟踪详情',
      statutoryChange: '法定变更信息',
      statutoryForm: {
        statutoryName: '法规名称',
        statutorySources: '法规来源',
        statutoryAbstract: '法规信息摘要',
        effectiveDate: '生效日期',
        changeFlag: '是否变更管理',
        status: '状态'
      },
      taskAllocation: '任务分配',
      taskInfo: '任务信息',
      taskFeedback: '任务反馈',
      taskInfoFrom: {
        taskContent: '任务描述',
        taskPerson: '责任人',
        endDate: '截止日期',
        taskRemark: '备注',
        completeDate: '完成日期',
        completeContent: '任务完成情况'
      }
    }
  },
  supplierSurveyOrderSummary: {
    breadcrumb: {
      breadcrumbOne: '法定管理',
      breadcrumbTwo: '船舶检验',
      breadcrumbThree: '供应商检验下单统计'
    },
    queryCriteria: {
      company: '公司',
      supplier: '供应商',
      queryDate: '下单日期'
    },
    table: {
      supplier: '供应商',
      counter: '下单次数',
      totalAmount: '总金额(本位币)'
    }
  }
};